import { render } from "./SavedView.vue?vue&type=template&id=4d78bc23&scoped=true"
import script from "./SavedView.vue?vue&type=script&lang=js"
export * from "./SavedView.vue?vue&type=script&lang=js"

import "./SavedView.vue?vue&type=style&index=0&id=4d78bc23&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d78bc23"]])

export default __exports__